export const translationNoSubcategory = {
  cz: {
    message: "Pro tuto kategorii nejsou dostupné podkategorie",
  },
  en: {
    message: "No subcategories available for the selected category",
  },
  de: {
    message: "Keine Unterkategorien verfügbar für die ausgewählte Kategorie",
  },
  es: {
    message: "No hay subcategorías disponibles para la categoría seleccionada",
  },
  fr: {
    message: "Aucune sous-catégorie disponible pour la catégorie sélectionnée",
  },
  hu: {
    message: "Nincsenek elérhető alkategóriák a kiválasztott kategóriához",
  },
  nl: {
    message: "Geen subcategorieën beschikbaar voor de geselecteerde categorie",
  },
  pl: {
    message: "Brak dostępnych podkategorii dla wybranej kategorii",
  },
  ru: {
    message: "Нет доступных подкатегорий для выбранной категории",
  },
  sk: {
    message: "Pre vybranú kategóriu nie sú dostupné žiadne podkategórie",
  },
};

export default translationNoSubcategory;
